import * as React from "react";

const HelpIconSVG = ({
    color = "#F8FAFC"
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill={color}
            d="m20 29.894-2.788-2.788H11.5v-17h17v17h-5.712zm-.052-5.682a.98.98 0 0 0 .724-.296.98.98 0 0 0 .295-.724.98.98 0 0 0-.295-.724.98.98 0 0 0-.724-.295.98.98 0 0 0-.724.295.98.98 0 0 0-.295.724q0 .429.295.724a.98.98 0 0 0 .724.296m-.707-3.581h1.407q.01-.378.052-.648a1.8 1.8 0 0 1 .167-.527q.126-.256.317-.493.193-.238.514-.56.798-.796 1.142-1.356.343-.558.343-1.27 0-1.248-.852-2.012Q21.479 13 20.137 13q-1.221 0-2.088.622a3.4 3.4 0 0 0-1.232 1.62l1.285.516q.213-.637.71-1.04.495-.403 1.244-.403.81 0 1.264.44.455.44.455 1.068 0 .463-.275.91-.275.445-.848.963-.396.351-.659.678a4 4 0 0 0-.437.674q-.176.346-.245.72-.07.374-.07.863"
        ></path>
    </svg>
);

export default HelpIconSVG;
